<template>
    <div style="width:100%;float:left;">
        <CButtonGroup>
            <CButton v-for="val in options" :color="selected === val ? 'success' : 'secondary'" @click="selected = val">{{val}}</CButton>
        </CButtonGroup>
        <spacer />
        <div style="width:100%;float:left;">
            <customer-scorecard :customer_selected="customer_selected" v-if="selected === 'Customer Scorecard'"></customer-scorecard>
            <customer-top-items :customer_selected="customer_selected" v-if="selected === 'Top Sold Items'"></customer-top-items>
            <customer-monthly-sales :customer_selected="customer_selected" v-if="selected === 'Monthly Sales'"></customer-monthly-sales>
        </div>
    </div>
  </template>
  <script>
  import CustomerScorecard from './customer_scorecard'
  import CustomerTopItems from './customer_top_items'
  import CustomerMonthlySales from './customer_monthly_sales'
  var methods = {}
  
  export default {
    // ===Component name
    name: "Customer360",
    // ===Props passed to component
    props: ['customer_selected'],
    // ===Components used by this component
    components: {
        CustomerScorecard,
        CustomerTopItems,
        CustomerMonthlySales
    },
    // ====component Data properties
    data(){
        return{
            selected: 'Customer Scorecard',
            options: ['Customer Scorecard', 'Top Sold Items', 'Monthly Sales']
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
  
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
  }
  </script>
  <!-- styles -->
  <!-- adding scoped attribute will apply the css to this component only -->
  <style scoped></style>
  